import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationFanSpeed
} from 'services/equipmentSets/types';
import { makeSelectCalibrationFanSpeed } from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    fanSpeed: CalibrationFanSpeed;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsFanSpeedListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { fanSpeed } = this.props;

        return <ListItem description="Fan speed" value={fanSpeed} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    fanSpeed: makeSelectCalibrationFanSpeed()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsFanSpeedListItemComponent
);
